import routerOptions0 from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.12.0_db0@0.2.3_ioredis@5.4.2_supports-_36967126bb4b787b983a3333236be67a/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}